<template>
  <div v-if="settings">
    <v-layout>
      <v-flex xs3>
        <content-field
          label="Enter the period of time in minutes"
          v-model="settings.loginTimeInMinutes"
          @input="$v.settings.loginTimeInMinutes.$touch"
          @blur="$v.settings.loginTimeInMinutes.$touch"
          :error="$v.settings.loginTimeInMinutes"
        />
      </v-flex>
      <v-flex xs3 offset-xs1>
        <content-field
          label="Enter the quantity of attempts"
          v-model="settings.allowedNumberOfAttemptsPerTime"
          :error="$v.settings.allowedNumberOfAttemptsPerTime"
          @input="$v.settings.allowedNumberOfAttemptsPerTime.$touch"
          @blur="$v.settings.allowedNumberOfAttemptsPerTime.$touch"
        />
      </v-flex>
    </v-layout>
    <v-layout >
      <v-flex xs3>
      <v-select
        :items="attendeeBlockedMessageTemplatesList"
        v-model="settings.attendeeBlockedEmailTemplateKey"
        item-text="templateKey"
        item-value="templateKey"
        label="Select email template"
        required
      />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs2>
        <v-btn
          color="primary"
          :disabled="$v.$invalid"
          @click="updateSettingsData"
        >
          Submit
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required, numeric } from 'vuelidate/lib/validators'
import {clone, path, pathOr} from 'ramda'
import mixins from '@/utils/mixins'

export default {
  name: 'block-attendee-settings',
  mixins: [mixins.emailTemplates],
  data () {
    return {
      settings: {
        allowedNumberOfAttemptsPerTime: '',
        loginTimeInMinutes: 0,
        attendeeBlockedEmailTemplateKey: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'getSettings'
    ]),
    getBlockAttendeeSettings () {
      return pathOr({'allowedNumberOfAttemptsPerTime': 0, 'loginTimeInMinutes': 0, attendeeBlockedEmailTemplateKey: ''},['globalSetting', 'blockAttendeeSettings'], this.getSettings)
    }
  },
  validations () {
    return {
      settings: {
        allowedNumberOfAttemptsPerTime: { required, numeric },
         loginTimeInMinutes: { required, numeric },
        attendeeBlockedEmailTemplateKey: {required}
      }
    }
  },
  watch: {
    getBlockAttendeeSettings (newVal) {
      this.settings = clone(newVal)
    }
  },
  methods: {
    ...mapActions([
      'updateBlockAttendeeSettings',
      'fetchGeneralSettings'
    ]),
    async updateSettingsData () {
      this.$v.settings.$touch()
      if (this.$v.settings.$invalid) return
      await this.updateBlockAttendeeSettings(this.settings)
    },
  },
  async created () {
    if (!this.getSettings) {
      await this.fetchGeneralSettings()
    }
    this.settings = clone(this.getBlockAttendeeSettings)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Settings/blockAttendeeSettings.vue